import React, { useState } from "react";
import { toast } from "react-toastify";
import DateTimePicker from "../components/DateTimePicker";
import { submitJoinTable } from "../services/joinTableService";
import ResyButton from "../components/ResyButton";
const ReservationForm: React.FC = () => {
  const handleReservation = () => {
    window.open("https://resy.com/cities/edison-nj/venues/house-of-bombay");
  };
  const [formData, setFormData] = useState({
    name: "",
    email: "",

    phone: "",
  });

  const [errors, setErrors] = useState<any>({});
  const [loading, setLoading] = useState(false);

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const validateForm = () => {
    const newErrors: any = {};

    if (!formData.name.trim()) {
      newErrors.name = "Name is required";
    }

    if (!formData.email.trim()) {
      newErrors.email = "Email is required";
    } else if (
      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(formData.email)
    ) {
      newErrors.email = "Invalid email address";
    }
    debugger;
    if (!formData.phone.trim()) {
      newErrors.phone = "Phone number is required";
    } else if (!/^[0-9]{7,10}$/.test(formData.phone)) {
      newErrors.phone = "Enter valid phone number";
    }

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    try {
      setLoading(true);

      const response = await submitJoinTable(formData);
      console.log(response);

      toast.success("Request submitted successfully!");
      setFormData({
        name: "",
        email: "",
        phone: "",
      });
    } catch (error: any) {
      console.error(error);

      if (error.status === 409) {
        toast.error(error.message);
      } else toast.success("Error occurred while form submission");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="reservation-section-form">
      <div className="hero-border">
        <div className="reservation-wrapper">
          {/* LEFT SIDE */}

          <div className="reservation-info">
            {/* <p className="tagline">
              --- AT HOUSE OF BOMBAY, THE TABLE IS WHERE EVERYTHING BEGINS.
            </p> */}
            <div className="line-heading">
              <div className="small-line"></div>
              <p className="explore" style={{ fontWeight: "700" }}>
                AT HOUSE OF BOMBAY, THE TABLE IS WHERE EVERYTHING BEGINS.
              </p>
            </div>

            <p className="description">
              Whether you're joining us for a familiar meal or a guided culinary
              journey, we look forward to hosting you. For lunch, dinner, and
              everyday gatherings, our main dining room is open for
              reservations.
            </p>

            <p className="description">
              Join us for our à la carte menu and Chai Bar experience, designed
              for shared plates, long conversations, and meals that unfold at
              their own pace.
            </p>

            <div className="contact-info">
              <table>
                <tr>
                  <td>PHONE :</td>
                  <td>
                    <a href="tel:17323531224" className="add-links">
                      +1 732-353-1224
                    </a>
                  </td>
                </tr>
                <tr>
                  <td>
                    <br />
                    EMAIL :
                  </td>
                  <td>
                    <br />
                    <a
                      href="mailto:info@houseofbombay.us"
                      className="add-links"
                    >
                      info@houseofbombay.us
                    </a>
                  </td>
                </tr>
                <tr>
                  <td style={{ verticalAlign: "top" }}>
                    <br />
                    ADDRESS :
                  </td>
                  <td>
                    <br />
                    House of Bombay <br />
                    1475 US-1 <br />
                    Edison <br />
                    NJ 08820
                  </td>
                </tr>
              </table>
            </div>

            <h2 className="opening-title">Opening Times</h2>

            <div className="opening-times">
              {[
                { day: "Monday", timing: "Closed" },
                { day: "Tuesday", timing: "05:00 PM - 10:00 PM" },
                { day: "Wednesday", timing: "05:00 PM - 10:00 PM" },
                { day: "Thursday", timing: "05:00 PM - 10:30 PM" },
                { day: "Friday", timing: "05:00 PM - 10:30 PM" },
                { day: "Saturday", timing: "05:00 PM - 10:30 PM" },
                { day: "Sunday", timing: "05:00 PM - 10:00 PM" },
              ].map((day, i) => (
                <div key={i} className="time-row">
                  <span>{day.day}</span>
                  <span>{day.timing}</span>
                </div>
              ))}
            </div>
          </div>

          {/* RIGHT SIDE FORM */}

          <div className="reservation-form">
            <h2 className="form-title" style={{ textAlign: "center" }}>
              Book a Table
            </h2>
            <div className="form-group" style={{ textAlign: "center" }}>
              <br />
              Reserve your table today and discover authentic flavors,
              handcrafted dishes, and genuine hospitality at House of Bombay.
            </div>
            <div className="form-group">
              {/* <ResyButton /> */}
              <button
                type="submit"
                className="submit-btn"
                onClick={handleReservation}
              >
                {loading ? "PLEASE WAIT..." : "JOIN THE TABLE"}
              </button>
            </div>
            {/* <form onSubmit={handleSubmit}>
              <div className="form-group">
                <input
                  type="text"
                  placeholder="NAME"
                  value={formData.name}
                  maxLength={30}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      name: e.target.value,
                    })
                  }
                />
                {errors.name && <span>{errors.name}</span>}
              </div>

              <div className="form-group">
                <input
                  type="email"
                  placeholder="EMAIL ADDRESS"
                  value={formData.email}
                  maxLength={30}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      email: e.target.value,
                    })
                  }
                />
                {errors.email && <span>{errors.email}</span>}
              </div>

              <div className="form-group">
                <input
                  type="text"
                  placeholder="PHONE NUMBER"
                  value={formData.phone}
                  maxLength={12}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      phone: e.target.value,
                    })
                  }
                />
                {errors.phone && <span>{errors.phone}</span>}
              </div>

              <button type="submit" className="submit-btn">
                {loading ? "PLEASE WAIT..." : "JOIN THE TABLE"}
              </button>
            </form> */}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ReservationForm;
